//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

export const enum OAuthLandingPageMessageType {
    OAuthCheckPassed = 'RightsRequestOAuthCheckPassed',
    OAuthCancelled = 'RightsRequestOAuthCancel',
    OAuthCheckFailed = 'RightsRequestOAuthCheckFailed',
}

export function isOAuthMessage(obj: unknown): obj is IOAuthLandingPagePostMessage {
  if (typeof obj !== 'object' || !obj) {
    return false;
  }
  switch ((obj as { type?: string }).type) {
    case OAuthLandingPageMessageType.OAuthCheckPassed:
    case OAuthLandingPageMessageType.OAuthCancelled:
    case OAuthLandingPageMessageType.OAuthCheckFailed:
      return true;
    default:
      return false;
  }
}

export interface IOAuthLandingPageSuccesstMessage {
  type: OAuthLandingPageMessageType.OAuthCancelled | OAuthLandingPageMessageType.OAuthCheckPassed;
}

export interface IOAuthLandingPageErrorMessage {
  type: OAuthLandingPageMessageType.OAuthCheckFailed;
  error: string;
}

export type IOAuthLandingPagePostMessage =
  IOAuthLandingPageSuccesstMessage |
  IOAuthLandingPageErrorMessage;
